export const limpiarCelular =  (celular) => {
    return celular.replace(/\D/g, '');
}